import type { Events } from '@setplex/pureya'
import type { IRewindState } from '~/features/rewind/useRewindState'
import type { UsePlayer } from '~/widgets/Player'

import { useCallback, useRef } from 'react'
import { RewindTypes } from '~/shared/constants/rewind'
import { isRewindableDurationLow } from './useRewindCallbacks/lib'

export type TOnGoLive = (event: any) => void

export const usePauseControl = ({
  enabled,
  liveProgressBar,
  rewindState,
  player,
  onLiveRewind,
}: {
  enabled: boolean
  liveProgressBar: Events.Media.ProgressBarChanged
  rewindState: IRewindState
  player: UsePlayer
  onLiveRewind: (value: number | undefined) => void
}): {
  onDelayedLiveRewind: (value: number | undefined) => void
} => {
  const { events } = player

  const delayedRewindValue = useRef(0)

  const { isRewound, rewindDetails, isRewindDelayed, setIsRewindDelayed } =
    rewindState
  const { rewindType } = rewindDetails

  const onDelayedLiveRewind = useCallback(
    (value?: number) => {
      if (isRewindableDurationLow(liveProgressBar) || !value || !enabled) return

      delayedRewindValue.current = value

      setIsRewindDelayed(true)
    },
    [enabled, liveProgressBar, setIsRewindDelayed]
  )

  events.on?.('play:rewind', () => {
    if (!delayedRewindValue.current || !isRewindDelayed) return

    const notTimeshift =
      rewindType === RewindTypes.dvr || rewindType === RewindTypes.rewind

    if (isRewound && notTimeshift) return // dvr and rewind keep playing from pause point with rewind url

    // if id dvr or rewind type and in "rewind mode", onLiveRewind uses seek.
    onLiveRewind(delayedRewindValue.current)
    setIsRewindDelayed(false)
    delayedRewindValue.current = 0
  })

  return { onDelayedLiveRewind }
}
